import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import "../../assets/css/Login.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { arrow } from "../../constant";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { SetResetPassword } from "../../redux/actions/AuthActions";
import queryString from "query-string";

function NewPassword() {
  const location = useLocation();
  const Token = useSelector((state) => state.AuthReducer.token);
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const value = queryString.parse(location.search);
  const token = value.token;
  const NewPasswordHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!password || !confirmPassword) {
      toast.error("Please Fill all fields");
      setLoading(false);
      return;
    }
    if (password !== confirmPassword) {
      toast.error("Password donot match");
      setLoading(false);
      return;
    }

    let data = {
      reset_token: token,
      password: password,
      confirm_password: confirmPassword,
    };
    setTimeout(async () => {
      let send = await dispatch(SetResetPassword(data, Navigate));
      setLoading(false);
      //   Navigate("/Signin");
    }, 600);
  };

  useEffect(() => {
    if (Token) {
      Navigate("/");
    }
  }, []);

  return (
    <>
      <Header />
      <section className="login">
        <div className="login-card">
          <div className="main-title-cont">
            <h2 className="main-title password_tilte">Create new password</h2>
          </div>
          <p className="forget-title password-title2">
            Your new password must be different from previous used passwords.{" "}
          </p>

          <div className="form-cont linkSetOtp">
            <div className="change_password_first">
              <div className="mb-3">
                <label>Password</label>
                <input
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                  className="input-custom"
                />
              </div>
              <span className="password-alert">
                Must be at least 8 characters.
              </span>
            </div>
            <div className="change_password_first ">
              <div className="mb-3">
                <label>Confirm Password</label>
                <input
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  type="password"
                  className="input-custom"
                />
              </div>
              {/* <span className="password-alert">Both passwords must match.</span> */}
            </div>

            <div className="btn-cont mt-5">
              <button
                className="btn bt-new-password-new w-100"
                onClick={(e) => NewPasswordHandler(e)}
                disabled={loading}
              >
                <span className="mr-2 text-white">
                  {loading ? "Loading..." : "Submit"}
                </span>{" "}
                <img src={arrow} className="img-fluid" />
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default NewPassword;
